module.exports = __webpack_public_path__ + "static/media/bhaskara.9981fc04.png";